import type { MemberWithRatings } from "../../types";

export type MemberFilter = "all" | "synthetic";

/** Spock cohorts and Gradient Doe are the synthetic rows; everything else is a real census member. */
export function isSyntheticMember(member: Pick<MemberWithRatings, "memberType">): boolean {
  return member.memberType !== "Real";
}

export function applyMemberFilter(members: readonly MemberWithRatings[], filter: MemberFilter): MemberWithRatings[] {
  return filter === "synthetic" ? members.filter(isSyntheticMember) : [...members];
}
